import React from 'react';
import './Header.css';
import { CurrentUserContext } from "../../../contexts/CurrentUserContext.js";
import { NavLink, Link} from 'react-router-dom'

export function Header(props) {
  const currentUser = React.useContext(CurrentUserContext);
  return (
    <header className='header '>
      {props.loggedIn &&
      <>
        <div className='header__logo'>
            <Link to='/' className={`header__brand font26Lobster color-white`} >MenuBook</Link> 
          </div>
      <nav className={`sidebar ${!props.loggedIn ? ('sidebar-hidden') : ''}`}>
      <ul className='sidebar__list'>
      <li className='sidebar__item item__link'><NavLink exact to="/data"  activeClassName="sidebar__active" className="sidebar__nav" >Данные</NavLink></li>
      <li className='sidebar__item item__link'><NavLink exact to="/ingredients"  activeClassName="sidebar__active" className="sidebar__nav" >Ингредиенты</NavLink></li>
      <li className='sidebar__item item__link'><NavLink exact to="/recipes"  activeClassName="sidebar__active" className="sidebar__nav" >Рецепты</NavLink></li>
      <li className='sidebar__item item__link'><NavLink exact to="/users"  activeClassName="sidebar__active" className="sidebar__nav" >Пользователи</NavLink></li>
      <li className='sidebar__item item__link'><NavLink exact to="/activ"  activeClassName="sidebar__active" className="sidebar__nav" >Активность</NavLink></li>
      <li className='sidebar__item item__link'><NavLink exact to="/monitoring"  activeClassName="sidebar__active" className="sidebar__nav" >Мониторинг</NavLink></li>
      <li className='sidebar__item item__link'><NavLink exact to="/analysis"  activeClassName="sidebar__active" className="sidebar__nav" >Анализ</NavLink></li>
      <li className='sidebar__item item__link'><NavLink exact to="/comments"  activeClassName="sidebar__active" className="sidebar__nav" >Комментарии</NavLink></li>
      <li className='sidebar__item item__link'><NavLink exact to="/payment"  activeClassName="sidebar__active" className="sidebar__nav" >Оплаты</NavLink></li>
     <li className='sidebar__item item__link'><NavLink exact to="/promocode"  activeClassName="sidebar__active" className="sidebar__nav" >Промокод</NavLink></li>
     
      </ul>
    </nav>
      <button onClick={props.onClick} className="font14SB buttonNone color-white">Выйти</button>
      </>
    }
    </header>
  )   
}
